import React, {useState, useEffect, Fragment, createContext} from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import CloseRounded from '@mui/icons-material/CloseRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';

import { DialogFormProvider, useDialogForm } from '../../contexts/DialogForm';
// import useFormDialog from '../../hooks/useFormDialog';

import { isEmpty } from 'lodash';

import useIsMobile from '../../hooks/useIsMobile';

import { BasicFlex } from '../Common';

const FormDialog = ({title, size = "md", saveText = "Save", cancelText = "Cancel", saveFunc = () => {}, text, toggle, children, loading, additionalButtons, useForm = false, disabled = false, ...props}) => {

  const { isMobile } = useIsMobile();

  const { open, setOpen, handleClickOpen, handleClose } = useDialogForm();

  const submitForm = async (e, button) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      let result;
      if (saveFunc || button) {
        if (button) {
          result = await button()
        } else {
          result = await saveFunc()
        };
      }
      handleClose();
    } catch (e) {
    } 
  }

  return (
    <Fragment>
      {toggle ? <div onClick={() => !disabled && handleClickOpen()} style={{width: "fit-content"}}>{toggle}</div> : null}
      {!open ? null : <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={size}
        fullWidth
        fullScreen={isMobile}
        onClick={(e) => e.stopPropagation()}
        // PaperProps={{
        //   component: 'form',
        //   onSubmit: submitForm
        // }}
        {...props}
      >
        <DialogTitle>
          <BasicFlex justifyContent="space-between">
            <div style={{flexGrow: 1}}>{title}</div>
            <IconButton onClick={handleClose} size="large">
              <CloseRounded />
            </IconButton>
          </BasicFlex>
        </DialogTitle>
        <DialogContent sx={{padding: isMobile ? 0 : 1}} onClick={(e) => e.stopPropagation()}>
          <DialogContentText>
            {text}
          </DialogContentText>
         {children}
        </DialogContent>
       {!useForm ? <DialogActions sx={{px: isMobile ? 0 : 3, py: isMobile ? 0 : 2}}>
          <Button onClick={handleClose}>{cancelText}</Button>
          {additionalButtons?.length ? additionalButtons.map(({text: buttonText, func, variant, color}, i) => (
            <Button key={i} variant={variant} color={color} onClick={(e) => submitForm(e, func)} loading={loading}>{buttonText}</Button>
            )) : null}
          <Button variant="contained" onClick={submitForm} loading={loading} startIcon={<SaveRoundedIcon />}>{saveText}</Button>
        </DialogActions> : null}
      </Dialog>}
    </Fragment>
  );
}


export default function DialogContainerComponent (props) {

  return (
    <DialogFormProvider forceClose={props.forceClose} forceOpen={props.forceOpen}>
      <FormDialog {...props} />
    </DialogFormProvider>
  );
}